import React, { Component } from "react";
import classNames from "classnames";
import classes from "./StreamYoutube.module.scss";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { ToastContainer, toast } from "react-toastify";
import getYoutubeId from "get-youtube-id";
import moment from "moment";
import { http, baseURL, baseURLWeb } from "../../misc/http";
import images from "../../commons/images";
import defautlPicture from "../../assets/default.jpg";

import fbIcon from "../../assets/fb.png";
import linkIcon from "../../assets/link.png";
import Layout from "../../layout/Main";
import VideoPlayer from "../../components/Event/VideoPlayer";

export default class StreamYoutube extends Component {
  state = {
    event: null,
    videoId: null,
  };

  getLocalData = async () => {
    let user = JSON.parse(localStorage.getItem("kominfo-psre"));
    this.setState({
      user: user,
      isLogin: user !== null ? true : false,
    });
  };

  onReady = (e) => {
    e.target.pauseVideo();
  };

  getEventById = async (id) => {
    let params = {
      method: "GET",
      path: "events/" + id,
      showMessage: false,
    };
    let { data } = await http(params);
    if (data.status === true && data.code === 200) {
      let { event } = this.state;
      event = data.data;
      this.setState({ event, videoId: getYoutubeId(event.webinarURL) });
    }
  };

  componentDidMount = async () => {
    console.log(this.props);
    let { id } = this.props.match.params;
    await this.getEventById(id);
  };

  render() {
    const option = {
      height: "390",
      width: "640",
      playerVars: {
        autoplay: 0,
        rel: 0,
        showinfo: 0,
        ecver: 2,
      },
    };
    return (
      <Layout>
        {this.state.event && (
          <section>
            <VideoPlayer video={this.state.videoId} options={option} />
            <div
              className={classNames("container row mx-auto", classes.content)}
            >
              <div className="col">
                {/* <div className="col-lg-7"> */}
                <div
                  className={classNames(
                    classes.titlePlc,
                    "justify-content-between"
                  )}
                >
                  <h3
                    className={classes.title}
                    style={{ fontSize: "25px", fontWeight: "600" }}
                  >
                    {this.state.event.title}
                  </h3>
                  <div className={classes.actionPlc}>
                    <a href="" className="mr-3">
                      <img
                        src={fbIcon}
                        alt="fb"
                        style={{ width: "25px", height: "25px" }}
                      />
                    </a>
                    <CopyToClipboard
                      text={`${baseURLWeb}${this.props.match.url.substring(
                        1,
                        this.props.match.url.length
                      )}`}
                      onCopy={(e) => {
                        {
                          /* console.log(url); */
                        }
                        toast.success("Link telah tersalin!", {
                          position: "top-right",
                          autoClose: 2000,
                          hideProgressBar: false,
                          closeOnClick: true,
                          pauseOnHover: false,
                          draggable: true,
                          progress: undefined,
                        });
                      }}
                    >
                      <a className={classes.cursor}>
                        <img
                          src={linkIcon}
                          alt="link"
                          style={{ width: "25px", height: "25px" }}
                        />
                      </a>
                    </CopyToClipboard>
                  </div>
                </div>
                <p className="text-muted">
                  {moment(this.state.event.startDate).format("ddd, MMMM DD")},{" "}
                  {this.state.event.startTime}
                </p>
                <div className={classes.toolsPlc}>
                  <p className="text-muted">
                    Kegiatan melalui Platform Streaming
                  </p>
                  <div className={classes.toolsIcon}>
                    <img
                      src={images[`${this.state.event.thirdPartyTool}Icon`]}
                      alt="tools"
                    />
                  </div>
                </div>
                <div
                  className="mt-4"
                  dangerouslySetInnerHTML={{
                    __html: this.state.event.description,
                  }}
                />
              </div>
              <div
                className={classNames(
                  classes.rightSection,
                  "col-lg-4 offset-lg-1 d-none"
                )}
              >
                <h4 style={{ fontSize: "20px", fontWeight: "600" }}>
                  Ajukan Pertanyaan
                </h4>
                <form onSubmit={(e) => e.preventDefault()}>
                  <input
                    className="form-control"
                    name={"name"}
                    onChange={(e) => console.log(e)}
                    placeholder="Nama kamu"
                  />
                  <textarea
                    name=""
                    id=""
                    cols="30"
                    rows="10"
                    className="form-control mt-3"
                    placeholder="Tuliskan Pertanyaan di sini"
                  />
                  <button className="btn btn-blue">KIRIM PERTANYAAN</button>
                </form>
                <p className={classes.orJoin}>Atau gabung di Ruang Meeting</p>
                <button className={classNames("btn btn-blue", classes.openBtn)}>
                  BUKA APLIKASI
                </button>
              </div>
            </div>
            <ToastContainer
              position="top-right"
              autoClose={2000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss={false}
              draggable
              pauseOnHover={false}
            />
          </section>
        )}
      </Layout>
    );
  }
}
